import React from 'react';
import LocationTemplate from './LocationTemplate';

const MurfreesboroPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Murfreesboro"
      stateName="North Carolina"
      countyName="Hertford"
      zipCodes={["27855"]}
      latitude={36.4382}
      longitude={-77.0997}
      population={2892}
      historicalFact="Founded in 1787, home to Chowan University (1848), one of the oldest historically black universities in the South."
      nearbyTowns={[
        "Ahoskie, NC",
        "Winton, NC",
        "Gatesville, NC",
        "Rich Square, NC",
        "Aulander, NC",
        "Powellsville, NC",
        "Como, NC",
        "Suffolk, VA"
      ]}
    />
  );
};

export default MurfreesboroPage;